export default "/list.3351cae02f2534bbf57a2e8ea76d3a3c.svg";